import React, { Component } from 'react';
import { Form, Container, Row, Col, Label, Input, Button, Alert, FormGroup, Table, Badge} from 'reactstrap';

export default class EditProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            profile: {
                firstName: '', middleName: '', lastName: '', careOf: '', occupation: '', website: '', mailingAddress1: '', mailingAddress2: '', mailingCity: '', mailingState: '', mailingZip: ''
                , addressUnincorporated: false, municipality: '', councilDistrict: '', homePhone: '', mobilePhone: '', email: '', politicalParty: '', spouseName: '', referredBy: '', votingRegistrationAtHome: ''
                , uscitizen: '', countyResident: '', military: '', militaryService: '', militaryBranch: '', militaryRank: '', militaryTypeOfDischarge: '', militaryServiceStartDate: '', militaryServiceEndDate: '', comments: ''
                , communityActivities: '', contracts: '', education: '', employment: '', financialInterests: '', governmentPositions: '', licensesCertificates: '', references: '' 
                , genderSex: '', ethnicityRace: '', councilDistrictNavigation: [], countyNavigation: [], politicalPartyNavigation: [], genderSexNavigation: [], communityActivitiesNavigation: []
                , boardMembers: [], contractsNavigation: [], educationNavigation: [], employmentNavigation: [], financialInterestsNavigation: [], governmentPositionsNavigation: [], licensesCertificatesNavigation: [], referencesNavigation: []
            }, 
            ethnicity: [],
            boards: [],
            commentCharCount: 0
        }
    }

    toCamelCase = (key, value) => {
        if (value && typeof value === 'object'){
            for (var k in value) {
              if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
                value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                delete value[k];
              }
            }
          }
          return value;
    }

    componentDidMount() {
        if(this.props.profile) {
            let {profile} = this.props;
            this.setState({ profile: JSON.parse(profile, this.toCamelCase)});
        } else {
            const { id } = this.props.match.params;

            if (id > 0) {

                fetch('/api/profiles/' + id, {
                    method: 'GET'
                })
                    .then(resp => resp.json())
                    .then(data => {
                        this.setState({ profile: data });
                    })

                // return Ethnicity List
                fetch('/api/codes/type/ethnicityrace', {
                    method: 'GET'
                })
                    .then(response => response.json())
                    .then(data => {
                        this.setState({ ethnicity: data });
                    })
            }
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.saveChanges();
    }

    saveChanges = () => {
        const payload = "[" + "{'op': 'replace', 'path': '/comments', 'value': '" + this.state.profile.comments + "'}" + "]";
        const { id } = this.props.match.params;

        fetch('/api/profiles/' + id, {
            method: 'PATCH',
            mode: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: payload
        })
        .then(response => {
            if (response.ok) {
                this.setState({ showSuccess: true })
            } else {
                response.json().then(data => { this.setState({ showError: true, errorMessage: data }) });
            }
        })
    }
      
    getDisplayPhoneNumber = (number) => {
        if (!number) {
            return '';
        }
        else if (isNaN(number)) {
            return number;
        }
        else {
            let numberStr = String(number);
            return numberStr.substr(0, 3) + "-" + numberStr.substr(3, 3) + "-" + numberStr.substr(6, 4);
        }
    }

    handleChange = event => {
        var commentText = event.target.value;
        this.setState({ profile: { ...this.state.profile, [event.target.name]: commentText }, commentCharCount: commentText.length });
    }

    showCharCount = (curCount, maxCount) => {
        var className = (curCount / .90) > maxCount ? 'text-input-count-very-near-end' : (curCount / .75) > maxCount ? 'text-input-count-near-end' : 'text-input-count-normal'
        return (<Label className={className} ><span className='text-input-count-title'>Character Count:</span> {curCount}/{maxCount} </Label>)
    }

    displayDate = (date) => {
        if(date) {
            return date.substring(0, date.indexOf('T'))
        }
        return '';
    }

    displayDate = (date) => {
        if(date) {
            return date.substring(0, date.indexOf('T'))
        }
        return '';
    }

    render() {
        const { profile, showSuccess, showError, errorMessage } = this.state;
        const showCommentCharCount = this.showCharCount(profile.comments ? profile.comments.length : 0, 4000);
 
        return (
            <div>
                {showSuccess &&
                    <Alert color='success' isOpen={showSuccess} toggle={this.toggleAlert}>
                        Your changes have been saved.
                    </Alert>
                }
                {showError &&
                    <Alert color='danger' isOpen={showError} toggle={this.toggleAlert}>
                        <p>An error occured saving your changes.  Nothing has been saved to the database.</p>
                        <p>{errorMessage}</p>
                    </Alert>
                }
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Contact Information</Badge>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md="6" lg="3">
                                <FormGroup>
                                    <Label>First Name</Label>
                                    <Input name="firstName" readOnly value={profile.firstName} />
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="6" lg="3">
                                <FormGroup>
                                    <Label>Middle Name</Label>
                                    <Input name="middleName" readOnly value={profile.middleName || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="6" lg="3">
                                <FormGroup>
                                    <Label>Last Name</Label>
                                    <Input name="lastName" readOnly value={profile.lastName} />
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="6" lg="3">
                                <FormGroup>
                                    <Label>Preferred Pronoun</Label>
                                    <Input name="pronoun" readOnly value={profile.pronoun} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md="12" lg="3">
                                <FormGroup>
                                    <Label>Care Of</Label>
                                    <Input name="careOf" readOnly value={profile.careOf || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="12" lg="3">
                                <FormGroup>
                                    <Label>Occupation</Label>
                                    <Input name="occupation" readOnly value={profile.occupation || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="12" lg="3">
                                <FormGroup>
                                    <Label>Website</Label>
                                    <Input name="website" readOnly value={profile.website || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="12" md="12" lg="3">
                                <FormGroup>
                                    <Label>County</Label>
                                    <Input name="countyNavigation" readOnly value={(profile.countyNavigation && profile.countyNavigation.description) || ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Home Street Address</Label>
                                    <Input name="mailingAddress1" readOnly value={profile.mailingAddress1 || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Home Street Address 2</Label>
                                    <Input name="mailingAddress2" readOnly value={profile.mailingAddress2 || ''} />
                                </FormGroup>
                            </Col>
                        </Row> 
                        <Row>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>City</Label>
                                    <Input name="mailingCity" readOnly value={profile.mailingCity || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>State</Label>
                                    <Input name="mailingState" readOnly value={profile.mailingState || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Zip Code</Label>
                                    <Input name="mailingZip" readOnly value={profile.mailingZip || ''} />
                                </FormGroup>
                            </Col>
                        </Row>  
                        <Row>
                            <Col sm="4">
                                <FormGroup id="addressUnincorporatedRadio" >
                                    <Label>Do you live in an unincorporated area?</Label>
                                    <Input name="addressUnincorporatedRadio" readOnly value={profile.addressUnincorporated ? 'Yes' : 'No'} />
                                </FormGroup>
                            </Col>
                            {profile.addressUnincorporated === false &&
                                <Col sm="4">
                                    <FormGroup>
                                        <Label>Municipality</Label>
                                    <Input name="municipality" readOnly value={profile.municipality || ''} />
                                    </FormGroup>
                                </Col>
                            }
                            <Col sm="4">
                                <FormGroup>
                                    <Label>County Council District</Label>
                                    <Input name="councilDistrict" readOnly value={(profile.councilDistrictNavigation && profile.councilDistrictNavigation.description) || ''} />   
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Home Phone Number</Label>
                                    <Input name="homePhone" readOnly value={this.getDisplayPhoneNumber(profile.homePhone)} />
                                </FormGroup>
                            </Col>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Cell Phone Number</Label>
                                    <Input name="mobilePhone" readOnly value={this.getDisplayPhoneNumber(profile.mobilePhone)} />
                                </FormGroup>
                            </Col>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Email Address</Label>
                                    <Input name="email" readOnly value={profile.email || ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Political Party</Label>
                                    <Input name="councilDistrict" readOnly value={(profile.politicalPartyNavigation && profile.politicalPartyNavigation.description) || ''} />   
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Spouse's Full Name</Label>
                                    <Input name="spouseName" readOnly value={profile.spouseName || ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="4" className="mt-auto">
                                <FormGroup id="votingRegistrationAtHome" >
                                    <Label>Are you registered to vote at the above home address?</Label>
                                    <Input name="votingRegistrationAtHome" readOnly value={profile.votingRegistrationAtHome ? 'Yes' : 'No'} />
                                </FormGroup>
                            </Col>
                            <Col sm="4" className="mt-auto">
                                <FormGroup id="uscitizen" >
                                    <Label>Are you a United States Citizen?</Label>
                                    <Input name="uscitizen" readOnly value={profile.uscitizen ? 'Yes' : 'No'} />
                                </FormGroup>
                            </Col>
                            <Col sm="4" className="mt-auto">
                                <FormGroup id="countyResident" >
                                    <Label>Are you a St. Louis County Resident?</Label>
                                    <Input name="countyResident" readOnly value={profile.countyResident ? 'Yes' : 'No'} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Military Service</Badge>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <FormGroup>
                                    <Label>
                                        Are you, or have you ever been, a member of the armed forces of the United States? If so, please list
                                        dates of service, branch of service, rank and type of discharge.
                                        </Label>
                                    <br />
                                    <FormGroup id="military" >
                                        <Input name="military" readOnly value={profile.military ? 'Yes' : 'No'} />
                                    </FormGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        {profile.military === true &&
                            <div>
                                <Row>
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label>Military Service</Label>
                                            <Input name="militaryService" readOnly value={profile.militaryService || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label>Military Branch</Label>
                                            <Input name="militaryBranch" readOnly value={profile.militaryBranch || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label>Military Rank</Label>
                                            <Input name="militaryRank" readOnly value={profile.militaryRank || ''} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label>Type of Discharge</Label>
                                            <Input name="militaryTypeOfDischarge" readOnly value={profile.militaryTypeOfDischarge || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label>Service Start Date</Label>
                                            <Input name='militaryServiceStartDate' readOnly value={profile.militaryServiceStartDate ? new Date(profile.militaryServiceStartDate).toLocaleDateString("en-US") : ""} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="4">
                                        <FormGroup>
                                        <Label>Service End Date</Label>
                                        <Input name='militaryServiceEndDate' readOnly value={profile.militaryServiceEndDate ? new Date(profile.militaryServiceEndDate).toLocaleDateString("en-US") : ""} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        }                                
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Gender</Label>
                                    <Input name="genderSex" readOnly value={(profile.genderSexNavigation && profile.genderSexNavigation.description) || ''} />   
                                </FormGroup>
                            </Col>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Ethnicity</Label>
                                    <Input name="ethnicityRace" readOnly value={(profile.ethnicityRaceNavigation && profile.ethnicityRaceNavigation.description) || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm="4">
                                <FormGroup>
                                    <Label>Disability</Label>
                                    <Input name="disability" readOnly value={(profile.disabilityNavigation && profile.disabilityNavigation.description) || ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12" md="6" lg="2">
                                <Badge className='admin-badge' color="secondary" pill>Community Activities</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Organization</th>
                                    <th>Responsibilities</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.communityActivities && profile.communityActivitiesNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='4'>There are no community activities.</td>
                                    </tr>
                                }
                                {profile.communityActivities && profile.communityActivitiesNavigation.length > 0 && profile.communityActivitiesNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.organization}</td>
                                            <td>{item.responsibilities}</td>
                                            <td>{this.displayDate(item.startDate)}</td>
                                            <td>{this.displayDate(item.endDate)}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Contracts</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.contractsNavigation && profile.contractsNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='4'>There are no contracts.</td>
                                    </tr>
                                }
                                {profile.contractsNavigation && profile.contractsNavigation.length > 0 && profile.contractsNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.name}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Education</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Degree</th>
                                    <th>Field of Study</th>
                                    <th>Institution</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.educationNavigation && profile.educationNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='6'>There are no educational studies.</td>
                                    </tr>
                                }
                                {profile.educationNavigation && profile.educationNavigation.length > 0 && profile.educationNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.degree}</td>
                                            <td>{item.fieldOfStudy}</td>
                                            <td>{item.institution}</td>
                                            <td>{this.displayDate(item.startDate)}</td>
                                            <td>{this.displayDate(item.endDate)}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Employment</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Organization</th>
                                    <th>Title</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Office Phone</th>
                                    <th>Cell Phone</th>
                                </tr>
                                <tr>
                                    <th>Address 1</th>
                                    <th>Address 2</th>
                                    <th>State</th>
                                    <th>Zip</th>
                                    <th>Fax</th>
                                    <th></th>
                                </tr>
                            </thead>

                            {profile.employmentNavigation && profile.employmentNavigation.length === 0 && 
                                    <tbody>
                                        <tr>
                                            <td colSpan='10'>There are no employment records.</td>
                                        </tr>
                                    </tbody>
                                }
                                {profile.employmentNavigation && profile.employmentNavigation.length > 0 && profile.employmentNavigation.map((item, i) => {
                                    return(
                                        <tbody key={i} style={{borderBottom: 'black 2px solid'}}>
                                            <tr>
                                                <td>{item.organizationName}</td>
                                                <td>{item.title}</td>
                                                <td>{this.displayDate(item.startDate)}</td>
                                                <td>{this.displayDate(item.endDate)}</td>
                                                <td>{this.getDisplayPhoneNumber(item.officePhone)}</td>
                                                <td>{this.getDisplayPhoneNumber(item.cellPhone)}</td>
                                            </tr>
                                            <tr>
                                                <td>{item.mailingAddress1}</td>
                                                <td>{item.mailingAddress2}</td>
                                                <td>{item.mailingState}</td>
                                                <td>{item.mailingZip}</td>
                                                <td>{this.getDisplayPhoneNumber(item.faxNumber)}</td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    )
                                })
                                }
                
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Financial Interests</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Interest</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.financialInterestsNavigation && profile.financialInterestsNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='2'>There are no financial interests.</td>
                                    </tr>
                                }
                                {profile.financialInterestsNavigation && profile.financialInterestsNavigation.length > 0 && profile.financialInterestsNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.interest}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Government Positions</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Position</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.governmentPositionsNavigation && profile.governmentPositionsNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='3'>There are no government positions.</td>
                                    </tr>
                                }
                                {profile.governmentPositionsNavigation && profile.governmentPositionsNavigation.length > 0 && profile.governmentPositionsNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.position}</td>
                                            <td>{this.displayDate(item.startDate)}</td>
                                            <td>{this.displayDate(item.endDate)}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>Licenses Certificates</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>License/Certificate Name</th>
                                    <th>Original License Date</th>
                                    <th>Licensing Agency</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.licensesCertificatesNavigation && profile.licensesCertificatesNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='3'>There are no licenses or certificates.</td>
                                    </tr>
                                }
                                {profile.licensesCertificatesNavigation && profile.licensesCertificatesNavigation.length > 0 && profile.licensesCertificatesNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.name}</td>
                                            <td>{this.displayDate(item.licenseDate)}</td>
                                            <td>{item.agency}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <Row>
                            <Col sm="12">
                                <Badge className='admin-badge' color="secondary" pill>References</Badge>
                            </Col>
                        </Row>
                        <Table className='admin-table' striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Relationship</th>
                                    <th>Phone Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profile.referencesNavigation && profile.referencesNavigation.length === 0 && 
                                    <tr>
                                        <td colSpan='3'>There are no references.</td>
                                    </tr>
                                }
                                {profile.referencesNavigation && profile.referencesNavigation.length > 0 && profile.referencesNavigation.map((item, i) => {
                                    return(
                                        <tr key={i}>
                                            <td>{item.name}</td>
                                            <td>{item.relationship}</td>
                                            <td>{item.phoneNumber}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </Table>
                    </Container>
                </FormGroup>
                <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <Container className="form-border">
                            <Row>
                                <Col sm="12">
                                    <Badge className='admin-badge' color="secondary" pill>Internal Comments</Badge>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Label >Comments are for internal use only and are not shown to the profile user.</Label>
                                </Col>
                            </Row>                          
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label for='comments'>Comments</Label>
                                        <Input type='textarea' rows={8} name='comments' maxLength={4000} value={profile.comments || ''} onChange={this.handleChange} />
                                        {showCommentCharCount}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Button variant="primary" type="submit">Submit</Button>
                                </Col>
                            </Row>   
                        </Container>                      
                    </FormGroup>                   
                </Form>
            </div>
        )
    }
}